module.exports = __webpack_public_path__ + "img/mer-logo.04d13373.svg";